var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-viewer"},[(_vm.src)?_c('img',{staticClass:"image",attrs:{"src":_vm.src,"alt":_vm.alt},on:{"error":_vm.handleError,"load":_vm.handleLoad}}):_c('div',{staticClass:"placeholder"},[_c('img',{attrs:{"src":_vm.placeholderSrc,"alt":_vm.alt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }